<template>
    <app-layout title="Organisations">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 ">
            <!-- Time & Attendance Checkin start from here -->
            <div class="flex justify-between my-3">
                <div>
                <h2 class="font-semibold text-lg text-gray-800 leading-tight">Time & Attendance</h2>
                <p class="text-xs">Today Wed, Jan 3, 2024</p>
                </div>
                <div>
                    <button
                        v-if="!checkedIn"
                        @click="checkIn"
                        class="content-center text-xs text-green-600 border-2 border-green-600 flex bg-transparent text-green-700 font-semibold py-2 px-3  rounded"
                    >
                        <img :src="'/imgs/clock.png'" alt="" class="left-text" />
                        &nbsp; 
                        <p class="flex flex-wrap content-end">Check In</p>
                    </button>
                    <button
                        v-if="checkedIn"
                        @click="checkOut"
                        class="content-center text-xs text-red-600 border-2 border-red-600 flex bg-transparent font-semibold  py-2 px-3 rounded"
                    >
                        <img :src="'/imgs/checkout.png'" alt="" class="left-text" />
                        &nbsp;
                        <p class="flex flex-wrap content-end">Check Out</p>      
                    </button>
                </div>
            </div>
            <!-- Time & Attendance checkin end -->

            <!-- CheckIn Check Out Section Star from here -->
            <div class=" flex justify-between ">
                <div class=" flex justify-start mt-3">
                    <span>
                        <p class="text-xs text-gray-500">Check In</p>
                        <p class="text-sm font-semibold">9:00 AM</p>
                    </span>
                    <span class="px-3">
                        <p class="text-xs text-gray-500">Check Out</p>
                        <p class="text-sm font-semibold">5:00 AM</p>
                    </span>

                </div>
                <div class="text-right">
                    <p>Total</p>
                    <h5 class="font-semibold">48h 05m</h5>
                   
                    <div class="flex justify-between">
                        <div>
                            <button
                                type="button"
                                class=" rounded-sm px-3 py-1 mtransition duration-500 ease select-none  focus:outline-none text-xs focus:shadow-outline" style="background-color: #E2F6DD;"
                            > In Progress
                            </button>
                           
                            <button
                                type="button"
                                class="rounded-sm px-3 py-1 transition duration-500 ease select-none text-xs focus:outline-none focus:shadow-outline" style="background-color: #e4e3e3;"
                            > Completed
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Time & Attendance checkin end -->

            <!-- box start from here -->
            <div class="bg-white overflow-hidden shadow-xl px-2 py-2 sm:rounded-lg my-3">
                <div class="py-5">
                  <h5>Time & Ateendance detail </h5>
                </div>
            </div>
        </div>
    </app-layout>
</template>   

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
export default {
    components: {
        AppLayout,
    },
    data() {
    return {
      checkedIn: false,
    };
  },

  methods: {
    checkIn() {
     
      this.checkedIn = true;
    },
    checkOut() {
     
      this.checkedIn = false;
    },
  },
}
</script>

<style>
p {
    margin-top: 0;
    margin-bottom: 0.1rem;
}

h2{
    margin-bottom: 0.1rem;   
}

</style>